// extracted by mini-css-extract-plugin
export default {"card__post":"card-practice_card__post__Nfchl","card__post__image":"card-practice_card__post__image__SbHTo","card__post__info":"card-practice_card__post__info__mgnao"};